import React from "react";

export default function BookProposal({ onClick }) {
    return (
        <>
            <div className="cvtemplate_pos">
                <div className="cvtemplate_bg">
                    <div className="cvtemplate_content">
                        <button className="close_btn" onClick={onClick} >
                            <img src="/assets/images/cross.svg" alt="" />
                        </button>
                        <h3>Book Proposal (2000-3000 words)</h3>

                    </div>
                    <ol className="cvtemplate_list">
                        <li>Outline of the Book's Central Idea;</li>
                        <li>Detailed Structure with Key Chapters/Sections with a Brief Description of each chapter/section,</li>
                        <li>Roadmap/Timeline of the Book.</li>
                      
                    </ol>
                </div>
            </div>
        </>
    )
}